import { render, staticRenderFns } from "./agogis-widget-course-card.vue?vue&type=template&id=3f0ffcaa"
import script from "./agogis-widget-course-card.vue?vue&type=script&lang=ts"
export * from "./agogis-widget-course-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports